import { render, staticRenderFns } from "./Lightbox.vue?vue&type=template&id=6c0577c8&scoped=true&"
import script from "./Lightbox.vue?vue&type=script&lang=js&"
export * from "./Lightbox.vue?vue&type=script&lang=js&"
import style0 from "./Lightbox.vue?vue&type=style&index=0&id=6c0577c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c0577c8",
  null
  
)

export default component.exports